import type { ActivityIndicatorProps } from 'react-native';
import { ActivityIndicator, View } from 'react-native';
import { cn as dsCn, useTheme } from '@vidahealth/vida-ds';

import { useDsEnabled } from '../../contexts/DesignSystem';
import { cn } from '../../utils/cn';

type LoadingProps = ActivityIndicatorProps & {
  className?: string;
  testID?: string;
};

const DsSpinner = (props: ActivityIndicatorProps) => {
  const { colors } = useTheme();
  return <ActivityIndicator size='large' color={colors['color-text-primary']} {...props} />;
};

const Loading = ({ className, testID, ...restProps }: LoadingProps) => {
  const dsEnabled = useDsEnabled();

  if (dsEnabled) {
    return (
      <View className={dsCn('flex flex-1 items-center justify-center', className)} testID={testID}>
        <DsSpinner {...restProps} />
      </View>
    );
  }

  return (
    <View className={cn('flex flex-1 items-center justify-center', className)} testID={testID}>
      <ActivityIndicator size='large' {...restProps} />
    </View>
  );
};

export default Loading;
